import { createApiSlice } from "@common";
import {
  CRUD_LEAD_SOURCE,
  GET_LEAD_SOURCE_BY_LEAD_ID,
} from "@routes";
// 1 to 1
const apiConfig = [
  {
    name: "addLeadSource",
    method: "post",
    url: CRUD_LEAD_SOURCE,
    stateKey: "message",
  },
  {
    name: "getLeadSourceByLeadId",
    method: "get",
    url: GET_LEAD_SOURCE_BY_LEAD_ID,
    stateKey: "details",
  },
];

const customReducers = {
  initialState: {
    data: [],
    details: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "leadSource",
  apiConfig,
  customReducers
);
const leadSourceSlice = slice;

export default leadSourceSlice.reducer;

export const {
  addLeadSource,
  deleteLeadSource,
  getLeadSourceByLeadId,
} = thunks;

export const { rowSelect } = actions;
